import React, { useEffect, useState } from "react";
import { backend } from "../../services/backend";
import { toast } from "sonner";
import ErrorPage from "../../pages/error";

const NewPasswordForm = (props: {token: string}) => {
  const [isPending, Pending] = useState(false);
  const [password, setPassword] = useState<string>("");
  const [passwordToConfirm, setPasswordToConfirm] = useState<string>("");
  const { token } = props

  const formPassHandler = () => {
    if (isPending) return;
    if (!password || password !== passwordToConfirm) {
      toast("Пароли не совпадают");
      return;
    }
    Pending(true);
    backend
      .recoverPassword(token, password)
      .then((res) => {
        if (res.error) {
          toast("Ошибка восстановления пароля");
        }
        toast("Пароль сброшен, авторизуйтесь заново");
        setTimeout(() => {
          document.location.href = "/";
        }, 3000);
      })
      .catch((e) => {
        toast("Ошибка восстановления пароля");
      })
      .finally(() => {
        setPassword("");
        setPasswordToConfirm("");
        Pending(false);
      });
  };

  return (
    <div className="loginform">
      <div className="loginFormHeading">
        <h3 className="heading3">Восстановление пароля</h3>
      </div>
      <div className="loginFormInner">
        <div className="fieldName">Новый пароль:</div>
        <div className="field">
          <input
            type="text"
            name="password"
            value={password}
            onChange={(event: any) => setPassword(event.target.value)}
          />
        </div>
        <div className="fieldName">Повторите пароль:</div>
        <div className="field">
          <input
            type="text"
            name="password-confirm"
            value={passwordToConfirm}
            onChange={(event: any) => setPasswordToConfirm(event.target.value)}
          />
        </div>
      </div>
      <div
        className={`btn loginActionButton${isPending ? " disabled" : ""}`}
        onClick={formPassHandler}
      >
        Задать новый пароль
      </div>
    </div>
  );
};

export default NewPasswordForm;
